import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import VendorApplicationOnboarding from '../../Components/VendorApplicationOnboarding/VendorApplicationOnboarding';
import appActions from '../App/actions';

const mapStateToProps = () => ({});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch admin actions
 */
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(appActions.logout()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorApplicationOnboarding),
);
